import axios from "axios";
import { defaultPath } from "./routes/defaultPath";


const cashImage: {[url: string]: string} = {}
export const getProfilePhoto = async (userId:string) => {
    if (cashImage[`${defaultPath}get_profile_photo/${userId}`]) {
        return cashImage[`${defaultPath}get_profile_photo/${userId}`]
    }
    try {
        const response = await axios.get(`${defaultPath}get_profile_photo/${userId}`);

        cashImage[`${defaultPath}get_profile_photo/${userId}`] = response.data.image;

        return response.data.image;
    } catch (error) {
        console.error('Error fetching profile photo:', error);
        return null
    }
};